module.exports = __webpack_public_path__ + "static/img/banner_h5_03_zh.00f1885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_h5_03_zh.png
// module id = zTsW
// module chunks = 34